null


// WEBPACK FOOTER //
// /Volumes/workplace/commands/DescribeCollectionCommand.ts